import { atom } from 'jotai';

/**
 * Atom to track whether the filters drawer is open
 */
export const isFiltersDrawerOpenAtom = atom<boolean>(false);

/**
 * Action atom to open the filters drawer
 */
export const openFiltersDrawerAtom = atom(null, (_get, set) => {
	set(isFiltersDrawerOpenAtom, true);
});

/**
 * Action atom to close the filters drawer
 */
export const closeFiltersDrawerAtom = atom(null, (_get, set) => {
	set(isFiltersDrawerOpenAtom, false);
});

/**
 * Action atom to toggle the filters drawer
 */
export const toggleFiltersDrawerAtom = atom(null, (get, set) => {
	set(isFiltersDrawerOpenAtom, !get(isFiltersDrawerOpenAtom));
});
